/**
 * Session payment-method mode helpers.
 * Merchant intent at create (specific mode) vs shopper selection during checkout.
 */

export function isPaymentMethodPinnedAtCreate(source) {
  if (source == null) return false;
  if (source.paymentMethodPinnedAtCreate === true) return true;
  if (source.payment_method_pinned_at_create === true) return true;
  return false;
}

/**
 * True when the hosted/embedded UI should skip the payment-method picker and
 * render the pinned method form directly (merchant specific-mode sessions only).
 */
export function shouldLockPaymentMethodSelector(
  checkoutProcessDto,
  paymentMethodPinnedAtCreate
) {
  if (!isPaymentMethodPinnedAtCreate({ paymentMethodPinnedAtCreate })) {
    return false;
  }
  const payment = checkoutProcessDto?.paymentData;
  return Boolean(
    payment?.currency && payment?.paymentMethod && payment?.gatewayName
  );
}
